/** Must match registry.constants.SERVERS_LIST_MAX_LIMIT */
export const SERVERS_LIST_MAX_LIMIT = 2000;
